export function client(data) {
    const { limit_max } = data;

    return {
        limitFiles: !!limit_max,
        maxFiles: limit_max ? parseInt(limit_max, 10) : "",
    };
}

export function server(data) {
    const { maxFiles } = data;

    return {
        limit_max: parseInt(maxFiles, 10) || null,
    };
}
